export default __webpack_public_path__ + "static/media/lightning-icon.3dcebb24.svg";